














































import Component from 'vue-class-component';
import Vue from 'vue';
import Toolbar from "./companents/Toolbar.vue";
import Home from "./pages/Home.vue";
import SettingsVue from "./companents/SettingsVue.vue";
import {State} from "./store";

@Component({
    components: {SettingsVue, Home, Toolbar}
})
export default class App extends Vue {

    state: State | any;

    loading = true;

    created(): void {
        this.state = this.$store.state;
    }

    mounted(): void {

    }
}
